/**
 * Defines the constants used by the Files module.
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 */
export const VUEX_FILES_INDEX_REQUEST            = 'VUEX_FILES_INDEX_REQUEST'
export const VUEX_FILES_INDEX_SUCCESS            = 'VUEX_FILES_INDEX_SUCCESS'
export const VUEX_FILES_INDEX_FAILURE            = 'VUEX_FILES_INDEX_FAILURE'
export const VUEX_FILE_SHOW_REQUEST              = 'VUEX_FILE_SHOW_REQUEST'
export const VUEX_FILE_SHOW_SUCCESS              = 'VUEX_FILE_SHOW_SUCCESS'
export const VUEX_FILE_SHOW_FAILURE              = 'VUEX_FILE_SHOW_FAILURE'

export const VUEX_FILE_CREATE_REQUEST            = 'VUEX_FILE_CREATE_REQUEST'
export const VUEX_FILE_CREATE_SUCCESS            = 'VUEX_FILE_CREATE_SUCCESS'
export const VUEX_FILE_CREATE_FAILURE            = 'VUEX_FILE_CREATE_FAILURE'


export const VUEX_FILE_UPDATE_REQUEST            = 'VUEX_FILE_UPDATE_REQUEST'

// This is going to be a monster
export const VUEX_FILE_HANDLE_FILE_NOTIFICATION  = 'VUEX_FILE_HANDLE_FILE_NOTIFICATION'
